import { useStatusBarAppearance } from './useStatusBarAppearance';

export type UsePageStatusBarOptions = {
  /** Hex (preferred for theme-color) matching the area directly under the status bar */
  background?: string;
  /** e.g. fullscreen loaders use '0px' so content fills under the inset strip */
  rootSafeAreaTop?: string;
  appleStatusBarStyle?: 'default' | 'black' | 'black-translucent';
};

/**
 * Sets status bar / iOS inset to match the page’s top chrome.
 * Omit `background` for a no-op (e.g. inline spinners).
 * For screens that show {@link LoadingSpinner} fullScreen, pass
 * `background: loading ? PAGE_CHROME_LOADER_BRAND_GREEN : pageTopColor` so the bar stays
 * correct when the spinner mounts (child layout effects run before parent).
 */
export function usePageStatusBar(options: UsePageStatusBarOptions = {}): void {
  const { background, rootSafeAreaTop, appleStatusBarStyle = 'black-translucent' } = options;
  useStatusBarAppearance(
    background
      ? {
          themeColor: background,
          topInsetColor: background,
          appleStatusBarStyle,
          ...(rootSafeAreaTop != null ? { rootSafeAreaTop } : {}),
        }
      : {}
  );
}
